import { render, staticRenderFns } from "./zzyShareList.vue?vue&type=template&id=04e83d3e&scoped=true"
import script from "./zzyShareList.vue?vue&type=script&lang=js"
export * from "./zzyShareList.vue?vue&type=script&lang=js"
import style0 from "./zzyShareList.vue?vue&type=style&index=0&id=04e83d3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e83d3e",
  null
  
)

export default component.exports